import { render } from "./UnitaTipologiaAvviso.vue?vue&type=template&id=fabcccfc&scoped=true"
import script from "./UnitaTipologiaAvviso.vue?vue&type=script&lang=js"
export * from "./UnitaTipologiaAvviso.vue?vue&type=script&lang=js"

import "./UnitaTipologiaAvviso.vue?vue&type=style&index=0&id=fabcccfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fabcccfc"]])

export default __exports__